import React from "react"
import type { AssessorFilterTab, AssessorSortOrder } from "../types"
import { ASSESSOR_SORT_LABELS } from "../types"
import "./AssessorFilters.style.scss"

interface AssessorFiltersProps {
  filter: AssessorFilterTab
  sort: AssessorSortOrder
  subject: string
  topic: string
  total: number
  questionCount: number
  paperCount: number
  subjects: string[]
  topics: string[]
  onFilter: (tab: AssessorFilterTab) => void
  onSort: (sort: AssessorSortOrder) => void
  onSubject: (value: string) => void
  onTopic: (value: string) => void
}

const AssessorFilters = ({
  filter,
  sort,
  subject,
  topic,
  total,
  questionCount,
  paperCount,
  subjects,
  topics,
  onFilter,
  onSort,
  onSubject,
  onTopic,
}: AssessorFiltersProps) => (
  <div className="assessor-filters">
    <div className="assessor-filters__tabs" role="tablist">
      {(
        [
          ["all", `All (${total})`],
          ["questions", `Questions (${questionCount})`],
          ["papers", `Papers (${paperCount})`],
        ] as Array<[AssessorFilterTab, string]>
      ).map(([id, label]) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={filter === id}
          className={filter === id ? "is-active" : undefined}
          onClick={() => onFilter(id)}
        >
          {label}
        </button>
      ))}
    </div>

    <div className="assessor-filters__controls">
      <select
        value={subject}
        onChange={(e) => onSubject(e.target.value)}
        aria-label="Filter by subject"
      >
        <option value="">All Subject</option>
        {subjects.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      <select
        value={topic}
        onChange={(e) => onTopic(e.target.value)}
        aria-label="Filter by topic"
      >
        <option value="">All Topics</option>
        {topics.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      <select
        value={sort}
        onChange={(e) => onSort(e.target.value as AssessorSortOrder)}
        aria-label="Sort assessments"
      >
        {(Object.keys(ASSESSOR_SORT_LABELS) as AssessorSortOrder[]).map(
          (key) => (
            <option key={key} value={key}>
              {ASSESSOR_SORT_LABELS[key]}
            </option>
          )
        )}
      </select>
    </div>
  </div>
)

export default AssessorFilters
